import React, { PureComponent } from 'react';
import styled from 'styled-components';

import NumberInput from './NumberInput';
import PriceDisplay from './PriceDisplay';
import ProductForm from './ProductForm';
import BasePrice from './BasePrice';
import ErrorMessage from './ErrorMessage';

const SubmitWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
`;

/**
 * Fabric selection component.
 */
class AddToCartForm extends PureComponent {

    Wrapper = styled(this.props.wrapper)`
        background-color:  ${props => props.theme.palette.secondary[50]};
    `;

    render() {
        return (
            <this.Wrapper className='stolo-cart-item'>
                <PriceDisplay />
                <SubmitWrapper>
                    <NumberInput />
                    <ProductForm />
                </SubmitWrapper>
                <BasePrice />
                <ErrorMessage
                    hasError={this.props.hasError}
                    message={this.props.message}
                />
            </this.Wrapper>
        );
    }
}


export default AddToCartForm;



// WEBPACK FOOTER //
// ./src/components/addtocart/AddToCartForm.js